import React, { useState, useEffect } from 'react';
import { 
  makeStyles, 
  Card, 
  CardContent, 
  Typography, 
  Grid, 
  Chip, 
  Divider, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  IconButton,
  Tooltip,
  Paper,
  Box,
  Avatar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  RadioGroup,
  Radio,
  Snackbar,
  CircularProgress,
} from '@material-ui/core';
import { 
  ExpandMore as ExpandMoreIcon, 
  FilterList as FilterListIcon,
  LocalOffer as LocalOfferIcon,
  Eco as EcoIcon,
  Terrain as TerrainIcon,
  Opacity as OpacityIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Edit as EditIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Close as CloseIcon
} from '@material-ui/icons';
import axios from 'axios'
import { connect } from 'react-redux'
import HerbicideBlendModal from './HerbicideBlendModal'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.grey[100],
    minHeight: '100vh'
  },
  header: {
    marginBottom: theme.spacing(3)
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-5px)',
      boxShadow: theme.shadows[8]
    }
  },
  cardContent: {
    flexGrow: 1
  },
  title: {
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center'
  },
  seasonWarm: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.contrastText,
    marginRight: theme.spacing(1)
  },
  seasonCold: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
    marginRight: theme.spacing(1)
  },
  seasonAll: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.contrastText,
    marginRight: theme.spacing(1)
  },
  typeChip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  divider: {
    margin: theme.spacing(1, 0)
  },
  chemicalItem: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.background.default
  },
  rateInfo: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  rateType: {
    fontWeight: 500,
    marginRight: theme.spacing(1)
  },
  rateValue: {
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey[200],
    fontSize: '0.85rem'
  },
  applicationArea: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText
  },
  filterContainer: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  filterTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  filterForm: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  },
  formControl: {
    minWidth: 220,
    marginBottom: theme.spacing(2)
  },
  statusIcon: {
    fontSize: 'small',
    marginRight: theme.spacing(1)
  },
  avatar: {
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.primary.main
  },
  editButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1)
  },
  dialogContent: {
    overflowY: 'auto',
    maxHeight: '80vh'
  },
  dialogPaper: {
    width: '100%',
    maxWidth: 800
  },
  chemicalSection: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: 'relative'
  },
  rateField: {
    width: 90,
    marginRight: theme.spacing(1)
  },
  unitField: {
    width: 80,
    marginRight: theme.spacing(1)
  },
  perField: {
    width: 110
  },
  removeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1)
  },
  actionButton: {
    margin: theme.spacing(1)
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 200
  }
}));

const ChemicalBlendsList = (props) => {
  const classes = useStyles();
  const [blends, setBlends] = useState([]);
  const [filteredBlends, setFilteredBlends] = useState([]);
  const [availableChemicals, setAvailableChemicals] = useState([]);
  const [filters, setFilters] = useState({
    season: '',
    type: '',
    applicationArea: '',
    active: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [currentBlend, setCurrentBlend] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isBlendModalOpen, setIsBlendModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedBlend, setSelectedBlend] = useState(null);

  // Fetch blends on component mount
  useEffect(() => {
    // fetchBlends();
    fetchChemicals();
  }, []);

  // // Fetch blends from API
  const fetchBlends = async () => {
    setLoading(true);
    try {
      const resp = await axios.get(`${props.url}/api/mobileapp/getGenericInfo?type=Chemical_Blends`);
      console.log('Fetched blends:', resp.data);
      if (resp.data?.length) {
        setBlends(resp.data);
        setFilteredBlends(resp.data);
      } else {
        setBlends([]);
        setFilteredBlends([]);
      }
    } catch (error) {
      console.error('Error fetching blends:', error);
      setSnackbarMessage('Error fetching blends');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  // Fetch available chemicals from API
  const fetchChemicals = async () => {
    setLoading(true)
    try {
      const resp = await axios.get(`${props.url}/api/mobileapp/getGenericInfo?type=ALL_CHEMICALS`);
      console.log('Fetched chemicals:', resp.data);
      const {
        chemicals,
        chemicalBlends
      } = resp.data
      if (chemicals?.length) {
        setAvailableChemicals(chemicals);
      } else {
        setAvailableChemicals([])
      }
    if (chemicalBlends?.length) {
      setBlends(chemicalBlends);
      setFilteredBlends(chemicalBlends)
    } else {
      setBlends([])
      setFilteredBlends([])
    }
    } catch (error) {
      console.error('Error fetching chemicals:', error);
      setSnackbarMessage('Error fetching chemicals');
      setSnackbarOpen(true);
    } finally {
      setLoading(false)
    }
  };

  // Filter blends based on current filters
  useEffect(() => {
    let result = [...blends];
    
    if (filters.season) {
      result = result.filter(blend => blend.season === filters.season);
    }
    
    if (filters.type) {
      result = result.filter(blend => blend.type === filters.type);
    }
    
    if (filters.applicationArea) {
      result = result.filter(blend => 
        blend.applicationAreas.includes(filters.applicationArea)
      );
    }
    
    if (filters.active !== '') {
      const isActive = filters.active === 'true';
      result = result.filter(blend => blend.active === isActive);
    }
    
    setFilteredBlends(result);
  }, [filters, blends]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getSeasonClass = (season) => {
    switch(season) {
      case 'Warm': return classes.seasonWarm;
      case 'Cold': return classes.seasonCold;
      case 'All': return classes.seasonAll;
      default: return '';
    }
  };

  const getSeasonIcon = (season) => {
    switch(season) {
      case 'Warm': return '🌞';
      case 'Cold': return '❄️';
      case 'All': return '🌱';
      default: return '';
    }
  };

  const handleCreateClick = () => {
    setEditMode(false);
    setSelectedBlend(null);
    setModalOpen(true);
  };

  const handleEditClick = (blend) => {
    setEditMode(true);
    setSelectedBlend(blend);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setEditMode(false);
    setSelectedBlend(null);
  };

  const handleCreateBlend = async (newBlend) => {
    setSaving(true);
    try {
      const blendData = {
        ...newBlend,
        active: true,
        createdByName: props.user?.name || 'Unknown User',
        createdDate: new Date().toISOString()
      };

      const resp = await axios.post(`${props.url}/api/hmi/saveChemicalBlend`, blendData);
      
      if (resp.data.success) {
        setSnackbarMessage('Blend created successfully');
        setSnackbarOpen(true);
        await fetchChemicals(); // Refresh the list
        handleModalClose();
      } else {
        throw new Error(resp.data.message || 'Failed to create blend');
      }
    } catch (error) {
      console.error('Error creating blend:', error);
      setSnackbarMessage(error.message || 'Error creating blend');
      setSnackbarOpen(true);
    } finally {
      setSaving(false);
    }
  };
  const handleUpdateBlend = async (updatedBlend) => {
    setSaving(true);
    try {
      const resp = await axios.put(
        `${props.url}/api/hmi/updateChemicalBlend?blendId=${updatedBlend._id}`, 
        updatedBlend
      );
      
      if (resp.data.success) {
        setSnackbarMessage('Blend updated successfully');
        setSnackbarOpen(true);
        await fetchChemicals(); // Refresh the list
        handleModalClose();
      } else {
        throw new Error(resp.data.message || 'Failed to update blend');
      }
    } catch (error) {
      console.error('Error updating blend:', error);
      setSnackbarMessage(error.message || 'Error updating blend');
      setSnackbarOpen(true);
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteBlend = async (blendId) => {
    if (!window.confirm('Are you sure you want to delete this blend?')) {
      return;
    }
    setSaving(true);
    try {
      const resp = await axios.delete(`${props.url}/api/hmi/deleteChemicalBlend?blendId=${blendId}`);
      
      if (resp.data.success) {
        setSnackbarMessage('Blend deleted successfully');
        setSnackbarOpen(true);
        await fetchChemicals(); // Refresh the list
        handleModalClose();
      } else {
        throw new Error(resp.data.message || 'Failed to delete blend');
      }
    } catch (error) {
      console.error('Error deleting blend:', error);
      setSnackbarMessage(error.message || 'Error deleting blend');
      setSnackbarOpen(true);
    } finally {
      setSaving(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentBlend(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCurrentBlend(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleApplicationAreaChange = (area) => {
    let newAreas;
    if (currentBlend.applicationAreas.includes(area)) {
      newAreas = currentBlend.applicationAreas.filter(a => a !== area);
    } else {
      newAreas = [...currentBlend.applicationAreas, area];
    }
    setCurrentBlend(prev => ({
      ...prev,
      applicationAreas: newAreas
    }));
  };

  const handleChemicalChange = (index, field, value) => {
    const updatedChemicals = [...currentBlend.chemicals];
    updatedChemicals[index] = {
      ...updatedChemicals[index],
      [field]: value
    };
    setCurrentBlend(prev => ({
      ...prev,
      chemicals: updatedChemicals
    }));
  };

  const handleRateChange = (index, rateType, field, value) => {
    const updatedChemicals = [...currentBlend.chemicals];
    
    if (!updatedChemicals[index][rateType]) {
      updatedChemicals[index][rateType] = { rate: 0, unit: 'oz', per: 'acre' };
    }
    
    updatedChemicals[index][rateType] = {
      ...updatedChemicals[index][rateType],
      [field]: field === 'rate' ? parseFloat(value) || 0 : value
    };
    
    setCurrentBlend(prev => ({
      ...prev,
      chemicals: updatedChemicals
    }));
  };

  const handleAddChemical = () => {
    const newChemical = {
      chemicalId: `temp-${Date.now()}`, // Temporary ID for new chemicals
      name: '',
      broadcast: { rate: 0, unit: 'oz', per: 'acre' }
    };
    
    setCurrentBlend(prev => ({
      ...prev,
      chemicals: [...prev.chemicals, newChemical]
    }));
  };

  const handleRemoveChemical = (index) => {
    const updatedChemicals = [...currentBlend.chemicals];
    updatedChemicals.splice(index, 1);
    setCurrentBlend(prev => ({
      ...prev,
      chemicals: updatedChemicals
    }));
  };

  const handleToggleRateType = (index, rateType) => {
    const updatedChemicals = [...currentBlend.chemicals];
    
    if (updatedChemicals[index][rateType]) {
      // Remove the rate type
      const { [rateType]: _, ...rest } = updatedChemicals[index];
      updatedChemicals[index] = rest;
      
      // Ensure at least one rate type exists
      if (!updatedChemicals[index].spot && !updatedChemicals[index].broadcast) {
        const defaultRateType = rateType === 'spot' ? 'broadcast' : 'spot';
        updatedChemicals[index][defaultRateType] = { rate: 0, unit: 'oz', per: 'acre' };
      }
    } else {
      // Add the rate type
      updatedChemicals[index][rateType] = { rate: 0, unit: 'oz', per: 'acre' };
    }
    
    setCurrentBlend(prev => ({
      ...prev,
      chemicals: updatedChemicals
    }));
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return (
      <div className={classes.root}>
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      </div>
    );
  }
  console.log('567...availableChemicals', availableChemicals)
  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h4" gutterBottom>
          Chemical Blends
        </Typography>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body1" color="textSecondary">
            {filteredBlends.length} blends found
          </Typography>
          <Box>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateClick}
              startIcon={<AddIcon />}
              style={{ marginRight: 8 }}
              disabled={saving}
            >
              Create Blend
            </Button>
            <Tooltip title="Toggle Filters">
              <IconButton 
                color={showFilters ? "primary" : "default"} 
                onClick={() => setShowFilters(!showFilters)}
              >
                <FilterListIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      
      {showFilters && (
        <Paper className={classes.filterContainer} elevation={2}>
          <div className={classes.filterTitle}>
            <FilterListIcon color="primary" style={{ marginRight: 8 }} />
            <Typography variant="h6">Filter Blends</Typography>
          </div>
          
          <div className={classes.filterForm}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Season</InputLabel>
              <Select
                name="season"
                value={filters.season}
                onChange={handleFilterChange}
                label="Season"
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="Warm">Warm</MenuItem>
                <MenuItem value="Cold">Cold</MenuItem>
                <MenuItem value="All">All</MenuItem>
              </Select>
            </FormControl>
            
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Type</InputLabel>
              <Select
                name="type"
                value={filters.type}
                onChange={handleFilterChange}
                label="Type"
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="Pre Emergent">Pre Emergent</MenuItem>
                <MenuItem value="Post">Post</MenuItem>
                <MenuItem value="Combo">Combo</MenuItem>
              </Select>
            </FormControl>
            
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Application Area</InputLabel>
              <Select
                name="applicationArea"
                value={filters.applicationArea}
                onChange={handleFilterChange}
                label="Application Area"
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="Ornamental/Right-of-Way">Ornamental/Right-of-Way</MenuItem>
                <MenuItem value="Turf">Turf</MenuItem>
                <MenuItem value="Bare Ground">Bare Ground</MenuItem>
              </Select>
            </FormControl>
            
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel>Status</InputLabel>
              <Select
                name="active"
                value={filters.active}
                onChange={handleFilterChange}
                label="Status"
              >
                <MenuItem value="">Any</MenuItem>
                <MenuItem value="true">Active</MenuItem>
                <MenuItem value="false">Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Paper>
      )}
      
      <Grid container spacing={3}>
        {filteredBlends.map(blend => (
          <Grid item xs={12} sm={6} md={4} key={blend._id}>
            <Card className={classes.card} elevation={3}>
              <CardContent className={classes.cardContent}>
                <Tooltip title="Edit Blend">
                  <IconButton 
                    size="small" 
                    className={classes.editButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditClick(blend);
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Box display="flex" alignItems="center">
                    <Chip 
                      size="small"
                      label={blend.season}
                      className={getSeasonClass(blend.season)}
                      icon={<LocalOfferIcon />}
                    />
                    {blend.active ? (
                      <Chip 
                        size="small" 
                        label="Active" 
                        color="primary" 
                        variant="outlined"
                        icon={<CheckCircleIcon className={classes.statusIcon} />}
                      />
                    ) : (
                      <Chip 
                        size="small" 
                        label="Inactive" 
                        color="default" 
                        variant="outlined"
                        icon={<CancelIcon className={classes.statusIcon} />}
                      />
                    )}
                  </Box>
                </Box>
                
                <Typography variant="h6" className={classes.title} gutterBottom>
                  {blend.name}
                </Typography>
                
                <Box my={1}>
                  <Chip 
                    size="small" 
                    label={blend.type} 
                    className={classes.typeChip}
                    icon={<EcoIcon fontSize="small" />}
                  />
                  <Typography variant="body2" color="textSecondary">
                    Calibration Rate: {blend.calibrationRate} gal/acre
                  </Typography>
                </Box>
                
                <Divider className={classes.divider} />
                
                <Box mb={1}>
                  <Typography variant="subtitle2" gutterBottom>
                    Application Areas:
                  </Typography>
                  <Box>
                    {blend.applicationAreas.map(area => (
                      <Chip 
                        key={area} 
                        size="small" 
                        label={area} 
                        className={classes.applicationArea}
                        icon={<TerrainIcon fontSize="small" />}
                      />
                    ))}
                  </Box>
                </Box>
                
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="chemicals-content"
                    id="chemicals-header"
                  >
                    <Typography variant="subtitle2">
                      Chemicals ({blend.chemicals.length})
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box width="100%">
                      {blend.chemicals.map((chemical, index) => (
                        <Paper key={`${chemical.chemicalId}_${index}`} className={classes.chemicalItem} variant="outlined">
                          <Typography variant="subtitle2">{chemical.name}</Typography>
                          
                          {chemical.broadcast && (
                            <div className={classes.rateInfo}>
                              <OpacityIcon fontSize="small" color="primary" style={{ marginRight: 4 }} />
                              <span className={classes.rateType}>Broadcast:</span>
                              <span className={classes.rateValue}>
                                {chemical.broadcast.rate} {chemical.broadcast.unit}/{chemical.broadcast.per}
                              </span>
                            </div>
                          )}
                          
                          {chemical.spot && (
                            <div className={classes.rateInfo}>
                              <OpacityIcon fontSize="small" color="secondary" style={{ marginRight: 4 }} />
                              <span className={classes.rateType}>Spot:</span>
                              <span className={classes.rateValue}>
                                {chemical.spot.rate} {chemical.spot.unit}/{chemical.spot.per}
                              </span>
                            </div>
                          )}
                        </Paper>
                      ))}
                    </Box>
                  </AccordionDetails>
                </Accordion>
                
                <Box mt={2} display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="caption" color="textSecondary">
                    Created by {blend.createdByName}
                  </Typography>
                  <IconButton
                    size="small"
                    color="secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteBlend(blend._id);
                    }}
                    disabled={saving}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      
      {/* Create New Blend Modal */}
      <HerbicideBlendModal
        open={modalOpen}
        onClose={handleModalClose}
        availableChemicals={availableChemicals}
        onSave={handleCreateBlend}
        onUpdate={handleUpdateBlend}
        onDelete={handleDeleteBlend}
        editMode={editMode}
        existingBlend={selectedBlend}
      />
      
      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        action={
          <IconButton 
            size="small" 
            color="inherit" 
            onClick={handleSnackbarClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authenticated: state.authenticated,
    notification: state.notification,
    url: state.url,
    entities: state.entities,
    perms: state.perms,
    user: state.user
  }
}

export default connect(mapStateToProps)(ChemicalBlendsList)
